import Api from "../Api";
import Confirm from "./Confirm";

const WidgetArea = {
    area: null,

    init: function ($el) {
        this.area = $el;
        this.setEvents();
    },
    draggableOn: function () {
        const self = this;
        $('a.widget-reorder').text(Lang.widgetreorderdone);
        $('.widget-area').sortable({
            placeholder: 'widget-drop',
            start: function () {
                self.area.addClass('ordering');
            },
            update: function () {
                $('.widget').trigger('update');
                self.reorder();
            }
        });
    },
    draggableOff: function () {
        $('a.widget-reorder').text(Lang.widgetreorder);
        $('.widget-area').removeClass('ordering').sortable('destroy');
    },

    resetWidget: function () {
        const self = this;
        Confirm({
            ok: Lang.reset,
            title: Lang.widgetreset,
            msg: Lang.widgetresetsure,
            onConfirm: function () {
                const url = `/api/widgets/${self.area.data('area')}/${self.area.data('related_id')}`;
                Api.send(url, {}, 'delete').done(function () {
                    location.reload();
                });
            }
        });
    },

    widgetForm: function ($el) {
        const self = this;
        const extra = {
            area: self.area.data('area'),
            name: $el.data('name'),
            id: $el.data('id'),
            related_id: $el.parents('[data-related_id]').data('related_id')
        };
        let url;
        let method;
        let title;

        if (extra.id == '-1') {
            method = 'post';
            url = `/api/widgets/${extra.area}`;
            title = Lang.widgetadd;
        } else {
            method = 'patch';
            url = `/api/widgets/${extra.area}/${extra.id}`;
            title = Lang.widgetedit;
        }

        Api.getTpl('widget-form', extra).done(function (response) {
            const tpl = _.template(response);
            Confirm({
                ok: Lang.save,
                title: title,
                msg: tpl(),
                onConfirm: function () {
                    const data = $('#widgetForm').aeroSerialize();
                    data.related_id = extra.related_id;
                    data.filters = {};
                    $('.filter').each(function () {
                        const name = $(this).attr('name');
                        delete data.name;
                        data.filters[name] = $(this).val();
                    });
                    Api.send(url, data, method).done(function (r) {
                        self.rerender($el.parents('.widget'), r);
                    });
                }
            });
        });
    },

    reorder: function () {
        const self = this;
        const order = {};
        const url = `/api/widgets/${self.area.data('area')}/${self.area.data('related_id')}/reorder`;
        this.area.find('.widget').each(function (index) {
            const widget = $(this);
            order[widget.data('id')] = index;
        });
        Api.send(url, {order: order}, 'post').done(function (r) {
            //console.log(r);
        });
    },

    rerender: function (widget, response) {
        const self = this;
        if (widget.length > 0) {
            widget.replaceWith(response.content);
        } else {
            self.area.append(response.content);
        }
    },

    deleteWidget: function ($el) {
        const self = this;
        Confirm({
            ok: Lang.delete,
            title: name,
            msg: Lang.delsure,
            onConfirm: function () {
                const url = `/api/widgets/${self.area.data('area')}/${self.area.data('related_id')}/${$el.parents('.widget').data('id')}`;
                Api.send(url, {}, 'delete').done(function () {
                    $el.parents('.widget').remove();
                });
            }
        });
        return false;
    },

    setEvents: function () {
        const self = this;
        // add widget
        $('.widget-menu ul a').on('click', function () {
            self.widgetForm($(this));
            return false;
        });
        // clicking edit button
        this.area.on('click', '.edit-widget', function () {
            self.widgetForm($(this));
            return false;
        });
        // clicking delete button
        this.area.on('click', '.delete-widget', function () {
            self.deleteWidget($(this));
            return false;
        });
        // reset widget area
        $('a.widget-reset').on('click', function () {
            self.resetWidget();
            return false;
        });

        $('a.widget-reorder').on('click', function () {
            if (self.area.hasClass('ordering')) {
                self.draggableOff();
            } else {
                self.draggableOn();
            }
        });
    }
};

export default WidgetArea;
